import { IconX } from '@tabler/icons-react';

import { List, ListItem, Surface } from '@cfa/react-components';

interface SearchBarSuggestionsProps {
  suggestions: string[];
  onSetSuggestion: (suggestion: string) => void;
  onRemoveSuggestion: (suggestion: string) => void;
}

const SearchbarSuggestionsDropdown: React.FC<SearchBarSuggestionsProps> = ({
  suggestions,
  onSetSuggestion,
  onRemoveSuggestion,
}) => (
  <Surface
    className="absolute inset-x-0 top-full z-5000"
    data-testid="DesktopSearchHistory"
    elevation={1}
  >
    <List className="p-0!" divider="inset" variant="default">
      {suggestions.map((suggestion, index) => (
        <ListItem
          className="cursor-pointer"
          data-testid={`SearchTermHistory${index}`}
          endItem={
            <IconX
              onClick={e => {
                e.stopPropagation();
                onRemoveSuggestion(suggestion);
              }}
            />
          }
          key={suggestion}
          onClick={e => {
            e.stopPropagation();
            onSetSuggestion(suggestion);
          }}
        >
          {suggestion}
        </ListItem>
      ))}
    </List>
  </Surface>
);

export default SearchbarSuggestionsDropdown;
